import React from 'react';

import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import { PortalsDeleteFormProps } from './PortalsDeleteForm.types';
import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';

export const PortalsDeleteForm = ({ id, onSubmit, data: { domain, portalId } }: PortalsDeleteFormProps) => {
  return (
    <AppModal
      id={id}
      title="Delete clip site"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={() => onSubmit(portalId)}
    >
      <p>
        Are you sure you want to delete
        <strong>
          <a href={`${process.env.REACT_APP_PORTALS_PROTOCOL}://${domain}`} target="_blank" rel="noopener noreferrer">
            &nbsp;{domain}&nbsp;
          </a>
        </strong>
        clip site?
      </p>
    </AppModal>
  );
};

export const PortalsDeleteModal = makeGuardedModal(SimpleModalId.DeletePortalModal, PortalsDeleteForm);
